(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medivio-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('medivio-bestsellers')) {
    customElements.define('medivio-bestsellers', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-mvbest-track]');
        this.prev = this.querySelector('[data-mvbest-prev]');
        this.next = this.querySelector('[data-mvbest-next]');
        this.progress = this.querySelector('[data-mvbest-progress]');
        if (!this.track || !this.prev || !this.next) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const move = direction => {
          const card = this.track.querySelector('.mv-best__card');
          if (!card) return;
          const style = getComputedStyle(this.track);
          const gap = parseFloat(style.columnGap || style.gap) || 0;
          const step = card.getBoundingClientRect().width + gap;
          const sign = style.direction === 'rtl' ? -1 : 1;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({left: sign * direction * step, behavior: reducedMotion ? 'auto' : 'smooth'});
        };
        this.prev.addEventListener('click', () => move(-1), {signal});
        this.next.addEventListener('click', () => move(1), {signal});
        this.track.addEventListener('scroll', () => this.updateCarousel(), {passive:true, signal});
        window.addEventListener('resize', () => this.updateCarousel(), {passive:true, signal});
        this.updateCarousel();
        requestAnimationFrame(() => this.updateCarousel());
      }
      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
      }
      updateCarousel() {
        if (!this.track || !this.prev || !this.next) return;
        const cards = this.track.querySelectorAll('.mv-best__card');
        if (!cards.length) return;
        const viewport = this.track.getBoundingClientRect();
        const first = cards[0].getBoundingClientRect();
        const last = cards[cards.length-1].getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.prev.disabled = rtl ? first.right <= viewport.right + 3 : first.left >= viewport.left - 3;
        this.next.disabled = rtl ? last.left >= viewport.left - 3 : last.right <= viewport.right + 3;

        if (!this.progress) return;
        const full = this.track.scrollWidth;
        const visible = this.track.clientWidth;
        if (full <= 0) return;
        const thumb = Math.min(100, visible / full * 100);
        const maxScroll = Math.max(0, full-visible);
        const pos = Math.min(maxScroll, Math.abs(this.track.scrollLeft));
        const start = maxScroll ? (pos/maxScroll)*(100-thumb) : 0;
        this.progress.style.width = thumb + '%';
        this.progress.style.insetInlineStart = start + '%';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medivio-equipment-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function activate(tab,focus){
    var list=tab.closest('[role="tablist"]'); if(!list)return;
    var root=list.closest('.mv-finder'); if(!root)return;
    var allTabs=Array.prototype.slice.call(list.querySelectorAll('[data-mvf-tab]'));
    var panels=Array.prototype.slice.call(root.querySelectorAll('[data-mvf-panel]'));
    allTabs.forEach(function(t){
      var active=t===tab;
      t.classList.toggle('is-active',active);
      t.setAttribute('aria-selected',active?'true':'false');
      t.setAttribute('tabindex',active?'0':'-1');
    });
    var target=tab.getAttribute('aria-controls');
    panels.forEach(function(p){p.hidden=p.id!==target;});
    if(focus)tab.focus();
  }
  document.addEventListener('click',function(e){
    var tab=e.target.closest('[data-mvf-tab]');
    if(tab)activate(tab,false);
  });
  document.addEventListener('keydown',function(e){
    var tab=e.target.closest('[data-mvf-tab]');if(!tab)return;
    var all=Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[data-mvf-tab]'));
    var i=all.indexOf(tab),next=-1;
    if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%all.length;
    if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i+all.length-1)%all.length;
    if(e.key==='Home')next=0;if(e.key==='End')next=all.length-1;
    if(next>=0){e.preventDefault();activate(all[next],true);}
  });
  document.addEventListener('shopify:block:select',function(e){
    var target=e.target.closest('[data-mvf-block],.mv-finder__editor-slot');
    if(!target)return;
    var root=target.closest('.mv-finder');
    if(!root)return;
    var panel=target.closest('[data-mvf-panel]');
    if(!panel)return;
    var tab=root.querySelector('[data-mvf-tab][aria-controls="'+panel.id+'"]');
    if(tab)activate(tab,false);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
